module.exports = __webpack_public_path__ + "img/智能烟感1.86b1baba.png";